export default __webpack_public_path__ + "static/media/dans-1080.7aa86114.jpg";